import { render, staticRenderFns } from "./tiyouyouAddKnowledge.vue?vue&type=template&id=76bf5eec&"
import script from "./tiyouyouAddKnowledge.vue?vue&type=script&lang=js&"
export * from "./tiyouyouAddKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports